import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthletePackage, AthletePackageCancel, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCancelAthletePackage(
  athletePackageId: string,
): UseMutationResult<AxiosResponse<AthletePackage>, AxiosError<ErrorMessage>, AthletePackageCancel> {
  const queryClient = useQueryClient();

  const cancelAthletePackage = (payload: AthletePackageCancel): Promise<AxiosResponse<AthletePackage>> => {
    return client.put(`athlete-packages/${athletePackageId}/cancel/`, payload);
  };

  return useMutation(cancelAthletePackage, {
    onSuccess: response => {
      queryClient.invalidateQueries(['athletePackages']);
      queryClient.invalidateQueries({
        queryKey: ['athletes', response.data.athlete],
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteStatuses', response.data.athlete],
      });
    },
  });
}
